module.exports = __webpack_public_path__ + "static/media/greenTick.2693ba27.svg";